<template>
  <box-section class="services-content">
    <router-link to="/"><img class="back-arrow" src="../assets/back-arrow-dark.svg" alt=""></router-link>
    <h1>Our Services</h1>
    <div class="services-grid">
      <router-link :to="'/services/' + service.post_name" class="service" v-for="service in services" :key="service.ID">
        <img :src="serviceIcons[service.post_name]"><p>{{ service.post_title }}</p>
      </router-link>
    </div>
  </box-section>
</template>

<script>
import BoxSection from './BoxSection'
import axios from 'axios'
export default {
  name: 'Services',
  components: { BoxSection },
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      services: [],
      serviceIcons: {
        'audit-of-financial-statements': require('../assets/service-icons/audit.svg'),
        'internal-audits': require('../assets/service-icons/internal.svg'),
        'other-assurance-and-advisory-services': require('../assets/service-icons/other.svg'),
        'public-service-audits-and-advisory': require('../assets/service-icons/public-service.svg'),
        'review-of-financial-statements': require('../assets/service-icons/review.svg'),
        'system-reviews-and-documentations': require('../assets/service-icons/system-reviews.svg'),
        'aml-cft-audits': require('../assets/service-icons/aml-laundering.svg')
      },
      metaInfo: {
        title: 'Services'
      }
    }
  },

  metaInfo () {
    return {
      title: this.metaInfo.title
    }
  },

  mounted () {
    axios.get(process.env.ENDPOINT, {
      params: {
        slug: 'services'
      }
    }).then(response => {
      this.metaInfo.title = response.data[0].title.rendered
      this.services = response.data[0].acf.services_grid.map(service => {
        return service.subpage
      })
      document.dispatchEvent(new Event('content-loaded'))
    }).catch(error => {
      console.log(error)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Services.vue